import * as types from './action-types';
import firebase from 'firebase/compat/app';
import _ from 'lodash';
import { APPS, ASSETS, INVOICES, REQUESTS } from 'components/constants';
import { 
    collection, 
    doc,
	getAggregateFromServer,
	getCountFromServer,
    getDoc,
    getDocs, 
    getFirestore, 
    limit,
    or,
    orderBy,
    query,
    sum, 
    where, 
} from 'firebase/firestore';

const db = getFirestore();

/*-----------------------------------------------*/
/*  Dashboard Analytics
/*-----------------------------------------------*/

export function getServiceRequestAnalytics(handle, appId, startDate, endDate) {

	return async dispatch => {
	
		dispatch({ type: types.ANALYTICS_SERVICE_REQUESTS + '_PENDING' });

		const coll = collection(db, handle + '/service-requests/service-requests');
		const q = query(coll, 
			where('deleted', '==', false),
            where('type', 'in', (appId == APPS.DISPATCH.id) ? ['service_request'] : ['asset_request', 'asset_record']),
			where('requestDate', '>=', startDate),
			where('requestDate', '<=', endDate),
		);
		const q2 = query(coll, 
			where('deleted', '==', false),
            where('type', 'in', (appId == APPS.DISPATCH.id) ? ['service_request'] : ['asset_request', 'asset_record']),
            where('statusId', '==', REQUESTS.INCOMPLETE.id),
			where('requestDate', '>=', startDate),
			where('requestDate', '<=', endDate),
		);
		const count = await getCountFromServer(q);
		const count2 = await getCountFromServer(q2);
		const sums = await getAggregateFromServer(q, {
			totalCost: sum('totalCost'),
			totalCompleted: sum('totalCompleted'),
		});
        const analytics_service_requests = { 
            count: count.data().count, 
            incomplete: count2.data().count, 
            totalCost: sums.data().totalCost, 
            totalCompleted: sums.data().totalCompleted,
        };

		dispatch({ type: types.ANALYTICS_SERVICE_REQUESTS + '_FULFILLED', data: analytics_service_requests });
	};
}

export function getQuoteAnalytics(handle, appId, startDate, endDate) {

	return async dispatch => {
	
		dispatch({ type: types.ANALYTICS_QUOTES + '_PENDING' });

		const coll = collection(db, handle + '/quotes/quotes');
		const q = query(coll, 
			where('deleted', '==', false),
            where('type', 'in', (appId == APPS.DISPATCH.id) ? ['service_request'] : ['asset_request', 'asset_record']),
			where('effective', '>=', startDate),
			where('effective', '<=', endDate),
		);
		const q2 = query(coll, 
			where('deleted', '==', false),
            where('type', 'in', (appId == APPS.DISPATCH.id) ? ['service_request'] : ['asset_request', 'asset_record']),
            where('approvedOption', '>', ''),
			where('effective', '>=', startDate),
			where('effective', '<=', endDate),
		);
		const count = await getCountFromServer(q);
		const count2 = await getCountFromServer(q2);
		const sums = await getAggregateFromServer(q, {
			totalCost: sum('totalCost'),
		});
		const sums2 = await getAggregateFromServer(q2, {
			totalApproved: sum('totalCost'),
		});
        const analytics_quotes = { 
            count: count.data().count, 
            approved: count2.data().count, 
            totalCost: sums.data().totalCost, 
            totalApproved: sums2.data().totalApproved,
        };

		dispatch({ type: types.ANALYTICS_QUOTES + '_FULFILLED', data: analytics_quotes });
	};
}
export function getInvoiceAnalytics(handle, appId, startDate, endDate) {

	return async dispatch => {
	
		dispatch({ type: types.ANALYTICS_INVOICES + '_PENDING' });

		const coll = collection(db, handle + '/invoices/invoices');
		const q = query(coll, 
			where('deleted', '==', false),
            where('type', 'in', (appId == APPS.DISPATCH.id) ? ['service_request'] : ['asset_request', 'asset_record']),
			where('invoiceDate', '>=', startDate),
			where('invoiceDate', '<=', endDate),
		);
		const q2 = query(coll, 
			where('deleted', '==', false),
            where('type', 'in', (appId == APPS.DISPATCH.id) ? ['service_request'] : ['asset_request', 'asset_record']),
            where('statusId', '==', INVOICES.PAID.id),
			where('invoiceDate', '>=', startDate),
			where('invoiceDate', '<=', endDate),
		);
		const count = await getCountFromServer(q);
		const count2 = await getCountFromServer(q2);
		const sums = await getAggregateFromServer(q, {
			totalInvoiced: sum('totals.grandTotal'),
		});
		const sums2 = await getAggregateFromServer(q2, {
			totalPaid: sum('totals.grandTotal'),
		});
        const analytics_invoices = { 
            count: count.data().count, 
            paid: count2.data().count, 
            totalInvoiced: sums.data().totalInvoiced, 
            totalPaid: sums2.data().totalPaid,
        };

		dispatch({ type: types.ANALYTICS_INVOICES + '_FULFILLED', data: analytics_invoices });
	};
}

/*-----------------------------------------------*/
/*  Assets
/*-----------------------------------------------*/

export function getAssetsAnalytics(handle, customerId) {

    return async dispatch => {
    
        dispatch({ type: types.ANALYTICS_ASSETS + '_PENDING' });

        const coll = collection(db, handle + '/assets/assets');
        const q = query(coll, 
            where('deleted', '==', false),
            where('customerId', '==', customerId),
        );
        const q2 = query(coll, 
            where('deleted', '==', false),
            where('customerId', '==', customerId),
            where('statusId', '==', ASSETS.SERVICE_REQUESTED.id)
        );
        const q3 = query(coll, 
            where('deleted', '==', false),
            where('customerId', '==', customerId),
            where('statusId', '==', ASSETS.SERVICE_IN_PROGRESS.id)
        );
        const coll2 = collection(db, handle + '/service-requests/service-requests');
        const q4 = query(coll2, 
            where('deleted', '==', false),
            where('customerId', '==', customerId),
        );
        const q5 = query(coll2, 
            where('deleted', '==', false),
            where('statusId', 'in', [REQUESTS.UNASSIGNED.id, REQUESTS.ASSIGNED.id, REQUESTS.INCOMPLETE.id, REQUESTS.INPROGRESS.id ]),
            where('customerId', '==', customerId),
        );
        const count = await getCountFromServer(q);
        const count2 = await getCountFromServer(q2);
        const count3 = await getCountFromServer(q3);
        const count4 = await getCountFromServer(q4);
        const count5 = await getCountFromServer(q5);
        const analytics_assets = { 
            assets: count.data().count, 
            requested: count2.data().count, 
            inProgress: count3.data().count,
            serviceRequests: count4.data().count,
            serviceOpen: count5.data().count
        };

        dispatch({ type: types.ANALYTICS_ASSETS + '_FULFILLED', data: analytics_assets });
    };
}
export function getTopAssets(handle, customerId, startDate, endDate) {

    return async dispatch => {

        if (startDate && endDate) {

            dispatch({ type: types.ANALYTICS_ASSETS_TOP + '_PENDING' });

            const query_ = query(collection(db, `${handle}/service-requests/service-requests`), 
                where('completedDate', '>=', startDate),
                where('completedDate', '<', endDate),
                where('customerId', '==', customerId),
                where('type', 'in', ['asset_request', 'asset_record']),
                where('deleted', '==', false),
                orderBy('totalCost', 'desc'),
                limit(50),
            );
    
            const querySnapshot = await getDocs(query_);
            
            var serviceRequests = [];
            querySnapshot.forEach((doc) => {
                serviceRequests.push({ ...doc.data() });
            });

            var topAssets = {}; // Tally top assets
            for (let request of serviceRequests) {
                let cumulative = (topAssets[request.assetId]) ? topAssets[request.assetId] : 0;
                topAssets[request.assetId] = cumulative + request.totalCost;
            }

            var topAssetArray = []; // Create array of top assets
            for (const [key, value] of Object.entries(topAssets)) {
                topAssetArray.push({ id: key, totalCost: value });
            }
            topAssetArray = _.orderBy(topAssetArray, ['totalCost'], ['desc']);
            topAssetArray = topAssetArray;

            // Load asset details
            let i = 0;
            for (let asset of topAssetArray) {
                const docSnap = await getDoc(doc(db, `${handle}/assets/assets`, asset.id));
                topAssetArray[i].asset = docSnap.data();
                i++;
            }

            const analytics_assets_top = topAssetArray;

            dispatch({ type: types.ANALYTICS_ASSETS_TOP + '_FULFILLED', data: analytics_assets_top });
            
        } else {
            dispatch({ type: types.ANALYTICS_ASSETS_TOP + '_CLEAR' });
        }
    };
}
export function getExpiringDocs(handle, customerId) {

    return async dispatch => {

        dispatch({ type: types.ANALYTICS_ASSETS_EXPIRING + '_PENDING' });

        const query_ = query(collection(db, handle + '/assets/assets'), or(
            where('docExpiring', '==', true), 
            where('docExpired', '==', true)
        ));

        const querySnapshot = await getDocs(query_);
        
        var assets = [];
        querySnapshot.forEach((doc) => {
            assets.push({ ...doc.data(), id: doc.id });
        });

        dispatch({ type: types.ANALYTICS_ASSETS_EXPIRING + '_FULFILLED', data: assets });
            
    };
}

/*-----------------------------------------------*/
/*  Customers
/*-----------------------------------------------*/

export function getCustomersAnalytics(handle, startDate, endDate) {

	return async dispatch => {
	
		dispatch({ type: types.ANALYTICS_CUSTOMERS + '_PENDING' });

		const coll = collection(db, handle + '/profiles/profiles');
		const q = query(coll, 
			where('type', '==', 'customer'),
			where('deleted', '==', false),
		);
		// const q2 = query(coll, 
		// 	where('deleted', '==', false),
        //     where('statusId', '==', REQUESTS.INCOMPLETE.id),
		// 	where('requestDate', '>=', startDate),
		// 	where('requestDate', '<=', endDate),
		// );
		const count = await getCountFromServer(q);
		// const count2 = await getCountFromServer(q2);
		// const sums = await getAggregateFromServer(q, {
		// 	totalCost: sum('totalCost'),
		// 	totalCompleted: sum('totalCompleted'),
		// });
        const analytics_customers = { 
            count: count.data().count, 
            // incomplete: count2.data().count, 
            // totalCost: sums.data().totalCost, 
            // totalCompleted: sums.data().totalCompleted,
        };

		dispatch({ type: types.ANALYTICS_CUSTOMERS + '_FULFILLED', data: analytics_customers });
	};
}
export function getTopCustomers(handle, appId, startDate, endDate) {

    return async dispatch => {

        if (startDate && endDate) {

            dispatch({ type: types.ANALYTICS_CUSTOMERS_TOP + '_PENDING' });

            const query_ = query(collection(db, `${handle}/service-requests/service-requests`), 
                where('completedDate', '>=', startDate),
                where('completedDate', '<', endDate),
                where('customerId', '!=', null),
                where('type', 'in', (appId == APPS.DISPATCH.id) ? ['service_request'] : ['asset_request', 'asset_record']),
                where('deleted', '==', false),
                orderBy('totalCost', 'desc'),
                limit(50),
            );
    
            const querySnapshot = await getDocs(query_);
            
            var serviceRequests = [];
            querySnapshot.forEach((doc) => {
                serviceRequests.push({ ...doc.data() });
            });

            var topCustomers = {}; // Tally top assets
            for (let request of serviceRequests) {
                if (parseInt(request.customerId) && request.totalCost > 0) {
                    let cumulative = (topCustomers[request.customerId]) ? topCustomers[request.customerId] : 0;
                    topCustomers[request.customerId] = cumulative + request.totalCost;
                }
            }

            var topCustomersArray = []; // Create array of top assets
            for (const [key, value] of Object.entries(topCustomers)) {
                topCustomersArray.push({ id: key, totalCost: value });
            }
            topCustomersArray = _.orderBy(topCustomersArray, ['totalCost'], ['desc']);
            topCustomersArray = topCustomersArray;

            // Load asset details
            let i = 0;
            for (let customer of topCustomersArray) {
                const docSnap = await getDoc(doc(db, `${handle}/profiles/profiles`, customer.id));
                topCustomersArray[i].customer = docSnap.data();
                i++;
            }

            const analytics_customers_top = topCustomersArray;

            dispatch({ type: types.ANALYTICS_CUSTOMERS_TOP + '_FULFILLED', data: analytics_customers_top });

        } else {
            dispatch({ type: types.ANALYTICS_CUSTOMERS_TOP + '_CLEAR' });
        }
    };
}

export function clearAnalytics() {

    return dispatch => {
        // dispatch({ type: types.INVOICES_DASHBOARD + '_CLEAR' });
    };
}
